import { FF, FieldSet, MultiSelect, Validators } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { useTemplateManageContext } from '~bank-document-templates/manage/context'

export const License = () => {
  const { formApi, data } = useTemplateManageContext()
  const { licenseTypeOptions, licenseSubtypeOptions } = data

  return (
    <FieldSet legend="License">
      <FormRow>
        <Col>
          <formApi.Field
            name="licenseTypes"
            validators={{
              onChange: ({ value, fieldApi }) => {
                const level = fieldApi.form.getFieldValue('level')
                if (level === 'license') {
                  return Validators.required.field(value)
                }
                return undefined
              }
            }}
            children={(field) => (
              <FF
                required={field.form.getFieldValue('level') === 'license'}
                field={field}
                label="Type(s)"
                input={(p) => (
                  <MultiSelect
                    {...p}
                    data={licenseTypeOptions}
                    data-qa="Type(s)"
                    hint="Select one or more license types"
                  />
                )}
              />
            )}
          />
        </Col>
        <Col>
          <formApi.Field
            name="licenseSubtypes"
            validators={{
              onChange: ({ value, fieldApi }) => {
                const level = fieldApi.form.getFieldValue('level')
                if (level === 'license') {
                  return Validators.required.field(value)
                }
                return undefined
              }
            }}
            children={(field) => (
              <FF
                required={field.form.getFieldValue('level') === 'license'}
                field={field}
                label="Subtype(s)"
                input={(p) => (
                  <MultiSelect
                    {...p}
                    data={licenseSubtypeOptions}
                    data-qa="Subtype(s)"
                    hint="Select one or more license subtypes"
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
    </FieldSet>
  )
}
